import { render, staticRenderFns } from "./SCardOrderComp.vue?vue&type=template&id=c30d467a&"
import script from "./SCardOrderComp.vue?vue&type=script&lang=js&"
export * from "./SCardOrderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports